import React = require('react');
import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, ButtonWidget, TabStyles, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import { useState } from 'react';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { ResetUserMfaVerifiers } from '~src/userSettings/serverApi/requests/ResetUserMfaVerifiers';

import { Messages } from '../../codegen/Localize';
import { IServerUserInfo } from '../../userManagement/users/models/IServerUserInfo';
import { ISiteUserInfo } from '../../userManagement/users/models/ISiteUserInfo';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';

export interface ManageMfaProps {
    serverUser: IServerUserInfo;
    changePasswordUrl: string;
    isDomainFamilyExternal: boolean;
    isDomainFamilyLocal: boolean;
    siteUser: ISiteUserInfo;
    isUserSelf: boolean;
    manageMfaUrl: string;
    isViewerAdmin: boolean;
}

export function ManageMfaUrl(manageMfaProps: ManageMfaProps): JSX.Element {

    const [isSubmitting, setSubmitting] = useState(false);
    return (
        <table>
            <tbody className={UserSettingsStyle.tbody}>
                {(!!manageMfaProps.manageMfaUrl && !!manageMfaProps.siteUser && manageMfaProps.siteUser.authenticationProviderId === 'TABID_WITH_MFA' && manageMfaProps.isUserSelf) &&
                    <tr>
                        <td className={UserSettingsStyle.labelText}></td>
                        <td className="tb-details-value">
                            <div className="tb-margin-top-wide tb-margin-left-wide">
                                <TextLinkWidget href={manageMfaProps.manageMfaUrl} kind={TextLinkKind.Standard} testId='manage-mfa-link' target='_blank' rel='noopener noreferrer'>
                                    {Messages.manageMfa()}
                                </TextLinkWidget>
                            </div>
                        </td>
                    </tr>
                }
                {(manageMfaProps.isViewerAdmin && !!manageMfaProps.siteUser && manageMfaProps.siteUser.authenticationProviderId === 'TABID_WITH_MFA') &&
                    <tr>
                        <td className={UserSettingsStyle.labelText}></td>
                        <td className="tb-details-value">
                            <div className="tb-margin-top-wide tb-margin-left-wide">
                                {isSubmitting ?
                                    <div style={{ marginTop: TabStyles.Spacing.SmallSpace! }}>
                                        <ActivitySpinnerWidget spinnerSize={ActivitySpinnerSize.Small} testId="submitting" />
                                    </div>
                                    : <ButtonWidget buttonType={ButtonType.Destructive} onClick={() => submit(setSubmitting, manageMfaProps)} testId='reset-mfa-button'>{Messages.resetMfa()}</ButtonWidget>
                                }
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    );
}

const submit = (setSubmitting: (submiting: boolean) => void, props: ManageMfaProps): void => {
    const toast = ToasterService.instance;
    setSubmitting(true);
    WebHttpClient.sendRequest(new ResetUserMfaVerifiers([props.siteUser.id])).
        then((result: IResult) => {
            if (result && result.errors && result.errors.length > 0) {
                toast.pop({ type: ToastType.Error, text: Messages.resetMfaError() });
            }
            else {
                toast.pop({ type: ToastType.Info, text: Messages.resetMfaSuccess() });
            }
            setSubmitting(false);
        });
};